const SELECTOR = "#form_two_factor";
const GROUP_SELECTOR = "[data-two-factor-inputs]";
const DIGIT_SELECTOR = "[data-two-factor-digit]";
const EXPIRY_STATUS_SELECTOR = "[data-two-factor-expiry-status]";
const EXPIRY_SECONDS_SELECTOR = "[data-two-factor-expiry-seconds]";
const RESEND_STATUS_SELECTOR = "[data-two-factor-resend-status]";
const RESEND_SECONDS_SELECTOR = "[data-two-factor-resend-seconds]";
const RESEND_BUTTON_SELECTOR = "[data-two-factor-resend-button]";
const SUBMIT_BUTTON_SELECTOR = "[data-two-factor-submit-button]";
const SUBMIT_SPINNER_SELECTOR = "[data-two-factor-submit-spinner]";
const SUBMIT_LABEL_SELECTOR = "[data-two-factor-submit-label]";
const COUNTDOWN_INITIALIZED_FLAG = "twoFactorCountdownBound";
const DEFAULT_LENGTH = 6;
const INITIALIZED_FLAG = "twoFactorAutoSubmitBound";
const AUTO_SUBMIT_DELAY_MS = 500;
const PASTE_INITIALIZED_FLAG = "twoFactorPasteBound";

function normalize(value, max) {
  return String(value || "")
    .replace(/\D+/g, "")
    .slice(0, max);
}

function requestFormSubmit(form) {
  if (typeof form.requestSubmit === "function") {
    form.requestSubmit();
  } else {
    form.submit();
  }
}

function setSubmittingState(form, isSubmitting) {
  const submitButton = form.querySelector(SUBMIT_BUTTON_SELECTOR);
  const submitSpinner = form.querySelector(SUBMIT_SPINNER_SELECTOR);
  const submitLabel = form.querySelector(SUBMIT_LABEL_SELECTOR);

  if (submitButton) {
    submitButton.disabled = isSubmitting;
    submitButton.setAttribute("aria-busy", isSubmitting ? "true" : "false");
  }

  if (submitSpinner) {
    submitSpinner.classList.toggle("d-none", !isSubmitting);
  }

  if (submitLabel) {
    submitLabel.textContent = isSubmitting ? "Trwa logowanie..." : "Potwierdź logowanie";
  }

  form.querySelectorAll(DIGIT_SELECTOR).forEach((input) => {
    input.disabled = isSubmitting;
  });
}

function scheduleAutoSubmit(form) {
  if (!form || form.dataset.twoFactorSubmitting === "1") return;

  form.dataset.twoFactorSubmitting = "1";
  setSubmittingState(form, true);

  window.setTimeout(() => {
    form.submit();
  }, AUTO_SUBMIT_DELAY_MS);
}

function getRemainingSeconds(deadline) {
  if (!Number.isFinite(deadline) || deadline <= 0) return 0;
  return Math.max(0, deadline - Math.floor(Date.now() / 1000));
}

function bindCountdowns(root) {
  const expiryStatus = root.querySelector(EXPIRY_STATUS_SELECTOR);
  const resendStatus = root.querySelector(RESEND_STATUS_SELECTOR);

  if (expiryStatus && expiryStatus.dataset[COUNTDOWN_INITIALIZED_FLAG] === "1") return;
  if (resendStatus && resendStatus.dataset[COUNTDOWN_INITIALIZED_FLAG] === "1") return;
  if (!expiryStatus && !resendStatus) return;

  const expiryDeadline = parseInt(expiryStatus?.dataset.expiresAt || "", 10);
  const attemptsLeft = parseInt(expiryStatus?.dataset.attemptsLeft || "0", 10) || 0;
  const expirySeconds = expiryStatus?.querySelector(EXPIRY_SECONDS_SELECTOR) || null;

  const resendDeadline = parseInt(resendStatus?.dataset.resendAvailableAt || "", 10);
  const resendSeconds = resendStatus?.querySelector(RESEND_SECONDS_SELECTOR) || null;
  const resendButton = root.querySelector(RESEND_BUTTON_SELECTOR);
  let intervalId = null;

  const render = () => {
    const expiryRemaining = getRemainingSeconds(expiryDeadline);
    if (expiryStatus) {
      if (expiryRemaining > 0) {
        if (expirySeconds) expirySeconds.textContent = String(expiryRemaining);
      } else {
        expiryStatus.textContent = `Kod wygasl. Pozostalo prob: ${attemptsLeft}.`;
      }
    }

    const resendRemaining = getRemainingSeconds(resendDeadline);
    if (resendStatus) {
      if (resendRemaining > 0) {
        if (resendSeconds) resendSeconds.textContent = String(resendRemaining);
      } else {
        resendStatus.hidden = true;
      }
    }

    if (resendButton && resendRemaining <= 0) {
      resendButton.disabled = false;
    }

    if (intervalId !== null && expiryRemaining <= 0 && resendRemaining <= 0) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  };

  render();

  if (getRemainingSeconds(expiryDeadline) > 0 || getRemainingSeconds(resendDeadline) > 0) {
    intervalId = window.setInterval(render, 1000);
  }

  if (expiryStatus) expiryStatus.dataset[COUNTDOWN_INITIALIZED_FLAG] = "1";
  if (resendStatus) resendStatus.dataset[COUNTDOWN_INITIALIZED_FLAG] = "1";
}

function bindSingleInput(input) {
  if (!input || input.dataset[INITIALIZED_FLAG] === "1") return;
  const form = input.form;
  if (!form) return;

  const max = parseInt(input.getAttribute("maxlength"), 10) || DEFAULT_LENGTH;
  let submitted = false;

  const submit = () => {
    if (submitted) return;
    if (typeof form.reportValidity === "function" && !form.reportValidity()) return;
    submitted = true;
    scheduleAutoSubmit(form);
  };

  input.addEventListener("input", () => {
    const clean = normalize(input.value, max);
    if (clean !== input.value) input.value = clean;
    if (clean.length >= max) submit();
  });

  input.addEventListener("paste", (event) => {
    const data = event.clipboardData || window.clipboardData;
    if (!data) return;
    const pasted = normalize(data.getData("text"), max);
    if (!pasted) return;
    event.preventDefault();
    input.value = pasted;
    if (pasted.length >= max) submit();
  });

  input.dataset[INITIALIZED_FLAG] = "1";
}

function bindOtpGroup(group) {
  if (!group || group.dataset[INITIALIZED_FLAG] === "1") return;

  const form = group.closest("form");
  const hiddenInput = form?.querySelector(SELECTOR);
  if (!form || !hiddenInput) return;

  const inputs = Array.from(group.querySelectorAll(DIGIT_SELECTOR));
  const max =
    parseInt(group.dataset.twoFactorLength || "", 10) ||
    parseInt(hiddenInput.getAttribute("maxlength"), 10) ||
    inputs.length ||
    DEFAULT_LENGTH;
  const digits = inputs.slice(0, max);
  if (!digits.length) return;

  let submitted = false;

  const focusInput = (index) => {
    const target = digits[index];
    if (!target) return;
    target.focus();
    if (typeof target.select === "function") target.select();
  };

  const syncHidden = () => {
    hiddenInput.value = digits.map((input) => normalize(input.value, 1)).join("");
    return hiddenInput.value;
  };

  const getActiveDigitIndex = () => {
    const activeElement = document.activeElement;
    const index = digits.findIndex((input) => input === activeElement);
    return index >= 0 ? index : 0;
  };

  const submit = () => {
    if (submitted) return;

    syncHidden();
    const firstIncompleteIndex = digits.findIndex((input) => normalize(input.value, 1).length !== 1);
    if (firstIncompleteIndex !== -1) {
      if (typeof form.reportValidity === "function") form.reportValidity();
      focusInput(firstIncompleteIndex);
      return;
    }

    submitted = true;
    scheduleAutoSubmit(form);
  };

  const fillDigits = (value, startIndex = 0) => {
    const chars = normalize(value, max - startIndex).split("");

    for (let index = startIndex; index < digits.length; index += 1) {
      digits[index].value = chars[index - startIndex] ?? "";
    }

    syncHidden();

    if (hiddenInput.value.length >= max) {
      submit();
      return;
    }

    focusInput(Math.min(startIndex + chars.length, digits.length - 1));
  };

  const handlePastedValue = (value, startIndex = getActiveDigitIndex()) => {
    const pasted = normalize(value, max - startIndex);
    if (!pasted) return false;

    fillDigits(pasted, startIndex);
    return true;
  };

  const onDocumentPaste = (event) => {
    if (!document.contains(group)) {
      document.removeEventListener("paste", onDocumentPaste, true);
      return;
    }

    const activeElement = document.activeElement;
    if (activeElement && activeElement !== document.body && !form.contains(activeElement)) {
      return;
    }

    const data = event.clipboardData || window.clipboardData;
    if (!data) return;

    const text = data.getData("text");
    if (!handlePastedValue(text)) return;

    event.preventDefault();
  };

  digits.forEach((input, index) => {
    input.addEventListener("focus", () => {
      if (typeof input.select === "function") input.select();
    });

    input.addEventListener("beforeinput", (event) => {
      const data = typeof event.data === "string" ? event.data : "";
      if (!data || normalize(data, max).length <= 1) return;

      if (event.inputType === "insertFromPaste" || event.inputType === "insertReplacementText") {
        event.preventDefault();
        handlePastedValue(data, index);
      }
    });

    input.addEventListener("input", () => {
      const clean = normalize(input.value, max);

      if (clean.length > 1) {
        fillDigits(clean, index);
        return;
      }

      input.value = clean;
      syncHidden();

      if (clean && index < digits.length - 1) {
        focusInput(index + 1);
      }

      if (hiddenInput.value.length >= max) {
        submit();
      }
    });

    input.addEventListener("keydown", (event) => {
      if (event.metaKey || event.ctrlKey || event.altKey) {
        return;
      }

      if (event.key === "Backspace" && !input.value && index > 0) {
        event.preventDefault();
        digits[index - 1].value = "";
        syncHidden();
        focusInput(index - 1);
        return;
      }

      if (event.key === "ArrowLeft" && index > 0) {
        event.preventDefault();
        focusInput(index - 1);
        return;
      }

      if (event.key === "ArrowRight" && index < digits.length - 1) {
        event.preventDefault();
        focusInput(index + 1);
        return;
      }

      if (event.key.length === 1 && /\D/.test(event.key)) {
        event.preventDefault();
      }
    });

    input.addEventListener("paste", (event) => {
      const data = event.clipboardData || window.clipboardData;
      if (!data) return;

      if (!handlePastedValue(data.getData("text"), index)) return;

      event.preventDefault();
    });
  });

  form.addEventListener("submit", (event) => {
    syncHidden();

    const firstIncompleteIndex = digits.findIndex((input) => normalize(input.value, 1).length !== 1);
    if (firstIncompleteIndex === -1) return;

    event.preventDefault();
    if (typeof form.reportValidity === "function") form.reportValidity();
    focusInput(firstIncompleteIndex);
  });

  hiddenInput.value = "";
  if (group.dataset[PASTE_INITIALIZED_FLAG] !== "1") {
    document.addEventListener("paste", onDocumentPaste, true);
    group.dataset[PASTE_INITIALIZED_FLAG] = "1";
  }
  group.dataset[INITIALIZED_FLAG] = "1";
}

export function initTwoFactorAutoSubmit(root = document) {
  bindCountdowns(root);

  const group = root.querySelector(GROUP_SELECTOR);
  if (group) {
    bindOtpGroup(group);
    return;
  }

  const input = root.querySelector(SELECTOR);
  if (input) bindSingleInput(input);
}
